import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faRotate } from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { findSet, skipSet, whereSet } from '../../store/filterSlice';
import { useTranslation } from 'react-i18next';
import useApi from '../../hooks/useApi';
import './Search.css';
//
// Компонент строки поиска по экспонентам мероприятия
//
const SearchExhibitors = ({ event }) => {
	const { t } = useTranslation();
    const dispatch = useDispatch();
    const find = useSelector(state => state.filter.find);
    const where = useSelector(state => state.filter.where);
    const categories = useSelector(state => state.filter.categories);
    const countries = useSelector(state => state.filter.countries);
    const dates = useSelector(state => state.filter.dates);
    const type = 'get';
	const method = '/exhibitors/presearch';
	const [ params, setParams ] = useState({ find, event: event._id, categories: categories.join(), countries: countries.join(), dates: dates.join() });
    // eslint-disable-next-line
	const [ data, error, isLoading ] = useApi({ type, method, params });
    const [ input, setInput ] = useState(find); // содержимое строки поиска
    const [ count, setCount ] = useState(0); // общий счетчик результатов в препоиске
    const [ results, setResults ] = useState([]); // результаты препоиска
    // строка, которая будет устанавливаться с задержкой относительно input
    const [ query, setQuery ] = useState(find);

    // Запуск полного поиска в основном окне
    // при вводе нового запроса,
    // или при нажатии на плашку предварительного поиска,
    // или по нажатию Enter в строке,
    // или по клику на иконку поиска.
    const doSearch = useCallback((newFind, newWhere) => {
        if(newWhere !== where || find !== newFind.trim()) {
            // Если не проверить эти параметры будет сброс при простом возврате из страницы экспонента
            dispatch(skipSet(0));
        }
        dispatch(findSet(newFind.trim()));
        dispatch(whereSet(newWhere));
    }, [ dispatch, find, where ]);

    // Мы хотим отправлять запрос на поиск автоматически после того, как пользователь закончил ввод.
    // Для этого используем для debouncing эту технику.
    useEffect(() => {
        const timeOutId = setTimeout(() => {
            // Эта проверка нужна не только для того, чтобы не делать лишние запросы,
            // но и для того, чтобы не сбрасывалась область поиска при возврате из карточки
            // участника, т.к. надо отличать установку input при первом рендере от нового ввода.
            if(input === query) return;
            setQuery(input);
            doSearch(input, 'index');
        }, 500);

        return () => clearTimeout(timeOutId);
    }, [ input, query, doSearch ]);

    // Меняем параметры предварительного поиска при изменении одного из них
    useEffect(() => {
        const params = {};
        if(query) params.find = query;
        if(event) params.event = event._id;
        if(categories) params.categories = categories.join();
        if(countries) params.countries = countries.join();
        if(dates) params.dates = dates.join();
        setParams(params);
    }, [ query, event, categories, countries, dates ]);

    // Обработка результата предварительного поиска
    useEffect(() => {
        if(!data) {
            setCount(0);
            return;
        }
        let count = 0;
        let results = [];
        // Просмотрим все ключи результатов поиска
        for(let key in data.search.results) {
            if (data.search.results.hasOwnProperty(key)) {
                count += data.search.results[key];
                if(data.search.results[key] > 0) {
                    results.push({ where: key, count: data.search.results[key] });
                }
            }
        }
        // Отсортируем результаты
        if(count > 0) {
            results.sort((a, b) => {
                // Плашка поиска по всем полям всегда должна быть первой
                if(a.where === 'everywhere') return -1;
                if(b.where === 'everywhere') return  1
                return b.count - a.count;
            });
        }
        // Запишем
        setCount(count);
        setResults(results);
    }, [ data ]);

    // Проверка нажатия на Enter в строке поиска
    // Отправляем запрос на поиск без указания области поиска
    const onKeyDown = (e) => {
        if(e.key === 'Enter') {
            doSearch(input, 'index');
        }
    };

    // Клик на плашке
    const onClick = (where) => {
        doSearch(input, where);
    };

	return (
        <div className='Search'>
			<input
				type='text'
				onChange={e => setInput(e.target.value)}
                onKeyDown={e => onKeyDown(e)}
                placeholder={t('search.placeholder')}
                value={input}
			/>
            {isLoading ?
            <FontAwesomeIcon icon={faRotate} className='icon fa-spin'/> :
            <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className='icon'
                style={{cursor:'pointer'}}
                onClick={() => doSearch(input, 'index')}
            />}

            {(!isLoading && data && count > 0) &&
            <div className='results'>
                <h3>{t('search.where')}</h3>

                {results.map(res => (
                    <span
                        key={res.where}
                        onClick={() => onClick(res.where)}
                        className={res.where === where ? 'checked' : null}
                    >
                    {t('search.' + res.where)}
                        <span>{res.count}</span>
                    </span>                    
                ))}
            </div>}

        </div>
	);
};

export default SearchExhibitors;
